import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState, PrivateCoursesPayload } from './type'
import {
  getAllPrivateCourses,
  saveRegistration,
  completeRegistration,
  updatePaymentOrderFailed
} from './api'

export const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    updateOtp: (state, action: PayloadAction<string>) => {
      state.userDetails.otp = action.payload
    },
    updateOtpModel: (state, action: PayloadAction<boolean>) => {
      state.showOtpModel = action.payload
    },
    updateHasError: (state, action: PayloadAction<boolean>) => {
      state.hasError = action.payload
    },
    updateCourse: (state, action: PayloadAction<PrivateCoursesPayload[]>) => {
      state.privateCourses = action.payload
    },
    reset: () => initialState
  },
  extraReducers: {
    [getAllPrivateCourses.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getAllPrivateCourses.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      state.privateCourses = action?.payload
    },
    [getAllPrivateCourses.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [saveRegistration.pending.toString()]: (state) => {
      state.isLoading = true
      state.showOtpModel = false
      state.hasError = false
    },
    [saveRegistration.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      state.showOtpModel = true
      state.userDetails = action?.payload.data
      state.hasError = !action.payload
    },
    [saveRegistration.rejected.toString()]: (state) => {
      state.isLoading = false
      state.hasError = true
    },
    [completeRegistration.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [completeRegistration.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      state.hasError = !action.payload
    },
    [completeRegistration.rejected.toString()]: (state) => {
      state.isLoading = false
      state.hasError = true
    },
    [updatePaymentOrderFailed.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [updatePaymentOrderFailed.fulfilled.toString()]: (state) => {
      state.isLoading = false
      state.hasError = false
    },
    [updatePaymentOrderFailed.rejected.toString()]: (state) => {
      state.isLoading = false
      state.hasError = true
    }
  }
})

export default registerSlice.reducer
